import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ed12974&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed12974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed12974')) {
      api.createRecord('0ed12974', component.options)
    } else {
      api.reload('0ed12974', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0ed12974&scoped=true", function () {
      api.rerender('0ed12974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantName/index.vue"
export default component.exports